/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useImpostazioni } from '../hooks/useImpostazioni';
import { titolare, emailPrivacy, attivita, inItalia, aggiornataIl } from '../utils/titolare';

const ACCENT = '#8B5CF6';

export default function Privacy() {
  const impostazioni = useImpostazioni();
  const email = emailPrivacy(impostazioni);
  const cosaFa = attivita(impostazioni);
  const italia = inItalia(impostazioni);
  const aggiornata = aggiornataIl(impostazioni);
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <Link to="/login" style={styles.backLink}><ArrowLeft size={15} /> Torna al login</Link>

        <h1 style={styles.title}>Informativa sul trattamento dei dati (personale interno)</h1>
        {aggiornata && <p style={styles.aggiornata}>Aggiornata al {aggiornata}</p>}

        <section style={styles.section}>
          <p>Questo gestionale tratta i dati personali di dipendenti/collaboratori (nome, cognome, email, telefono, ore lavorate, interventi assegnati) per finalità di gestione del rapporto di lavoro/collaborazione e organizzazione dell'attività aziendale, oltre ai dati dei clienti necessari per l'erogazione del servizio di {cosaFa}.</p>
          <p>Titolare del trattamento: {titolare(impostazioni)}</p>
          {impostazioni.privacy_dpo && <p>Responsabile della protezione dei dati (DPO): {impostazioni.privacy_dpo}.</p>}
          <p>I dati sono trattati sulla base del rapporto contrattuale/di collaborazione in essere e degli obblighi di legge applicabili. Sono conservati per la durata del rapporto e, successivamente, per i termini previsti dalla normativa applicabile.</p>
          <p>È possibile esercitare i diritti previsti dagli articoli 15-22 del GDPR (accesso, rettifica, cancellazione, limitazione, portabilità, opposizione){email ? <> scrivendo a <a href={`mailto:${email}`} style={{ color: ACCENT, fontWeight: 600 }}>{email}</a></> : ' contattando il titolare del trattamento'}.</p>
          <p>Il conferimento dei dati necessari alla gestione del rapporto di lavoro o di collaborazione e agli adempimenti di legge è obbligatorio: in mancanza non è possibile dare esecuzione al rapporto.</p>
          <p>{impostazioni.privacy_trasferimenti}</p>
          <p>Non vengono effettuati trattamenti automatizzati che producano effetti giuridici o incidano in modo analogamente significativo sull'interessato, né attività di profilazione. Le ore registrate tramite il timer non sono utilizzate per valutazioni automatiche.</p>
          <p>È inoltre possibile proporre reclamo{italia ? ' al Garante per la protezione dei dati personali' : " all'autorità di controllo competente"}.</p>
        </section>
      </div>
    </div>
  );
}

const styles = {
  wrapper: { minHeight: '100vh', backgroundColor: '#F9FAFB', padding: '2rem 1rem' },
  container: { maxWidth: '680px', margin: '0 auto', backgroundColor: 'white', borderRadius: '12px', padding: '2rem', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' },
  backLink: { display: 'inline-flex', alignItems: 'center', gap: '0.35rem', color: ACCENT, textDecoration: 'none', fontSize: '0.88rem', fontWeight: 600, marginBottom: '1.25rem' },
  aggiornata: { fontSize: '0.82rem', color: '#6B7280', marginTop: '-0.5rem', marginBottom: '1rem' },
  title: { fontSize: '1.35rem', fontWeight: 700, margin: '0 0 1.25rem', color: '#111827' },
  section: { color: '#374151', fontSize: '0.92rem', lineHeight: 1.6, display: 'flex', flexDirection: 'column', gap: '0.85rem' },
};
